import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import { useEffect, useState } from "react";

// Animation fade-in
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
`;

export default function EventInfo({ event }) {

    // ❗ Les hooks doivent être appelés AVANT tout return conditionnel
    const [showTicker, setShowTicker] = useState(event?.showTicker || false);
    const [tickerMessage, setTickerMessage] = useState(
        event?.tickerMessage || "Bienvenue – Résultats en direct sur 321‑TIMING.ch"
    );

    // 🔄 Mise à jour automatique si la configuration change dans un autre onglet
    useEffect(() => {
        const handleStorage = () => {
            const saved = JSON.parse(localStorage.getItem("eventConfig") || "{}");
            setShowTicker(saved.showTicker || false);
            setTickerMessage(saved.tickerMessage || "");
        };

        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    // 🔄 Mise à jour locale si "event" change
    useEffect(() => {
        setShowTicker(event?.showTicker || false);
        setTickerMessage(event?.tickerMessage || "");
    }, [event]);

    // ❗ Le return conditionnel doit venir APRÈS les hooks
    if (!event) return null;


    return (
        <Box sx={{ mb: 3 }}>
            {/* Bandeau principal */}
            <Box
                sx={{
                    borderBottom: "3px solid #f1242e",
                    mb: 2,
                    pb: 2,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 3,
                    animation: `${fadeIn} 0.6s ease-out`,
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                    borderRadius: "8px",
                    backgroundColor: "#ffffff",
                }}
            >
                {/* Logo gauche */}
                <Box
                    sx={{
                        width: 130,
                        height: 130,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={event.logoLeft}
                        alt="Logo course"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            animation: `${fadeIn} 0.8s ease-out`,
                        }}
                    />
                </Box>

                {/* Infos course */}
                <Box
                    sx={{
                        textAlign: "center",
                        flexGrow: 1,
                        animation: `${fadeIn} 0.9s ease-out`,
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            color: "#022a5b",
                            fontWeight: "bold",
                            mb: 1,
                            animation: `${fadeIn} 1s ease-out`,
                        }}
                    >
                        {event.name}
                    </Typography>

                    <Typography sx={{ color: "#022a5b", fontSize: "1rem" }}>
                        {event.date} – {event.location}
                    </Typography>

                    {/* Nouveau titre LIVETIMING */}
                    <Typography
                        variant="h6"
                        sx={{
                            mt: 2,
                            color: "#022a5b",
                            fontWeight: "bold",
                            display: "inline-block",
                            borderBottom: "3px solid #f1242e",
                            pb: 0.5,
                        }}
                    >
                        Livetiming
                    </Typography>
                </Box>

                {/* Logo droite */}
                <Box
                    sx={{
                        width: 130,
                        height: 130,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={event.logoRight}
                        alt="321 Timing"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            animation: `${fadeIn} 0.8s ease-out`,
                        }}
                    />
                </Box>
            </Box>

            {/* Bande défilante (ticker) */}
            {showTicker && (
                <Box
                    sx={{
                        mt: -1,
                        py: 0.5,
                        backgroundColor: "#f8f8f8",
                        borderTop: "2px solid #f1242e",
                        borderBottom: "2px solid #f1242e",
                        color: "#022a5b",
                        fontWeight: 600,
                        overflow: "hidden",
                        animation: `${fadeIn} 0.7s ease-out`,
                    }}
                >
                    <marquee behavior="scroll" direction="left" scrollamount="5">
                        {tickerMessage}
                    </marquee>
                </Box>
            )}
        </Box>
    );
}